import { FC } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

type RouteProps = {
  children: any;
};

export const PrivateRoute: FC<RouteProps> = ({ children }) => {
  const { clientToken } = useSelector((state: any) => state.rootReducer.auth);
  return clientToken ? children : <Navigate to="/auth/login" replace />;
};

export const PublicRoute: FC<RouteProps> = ({ children }) => {
  const { clientToken } = useSelector((state: any) => state.rootReducer.auth);
  return clientToken ? <Navigate to="/" /> : children;
};
